export const SECTION_THEMES = {
  patient: { bg: "#eff5fd", accent: "#1f6fc2", catColor: "#000000" }, // 1. Patient Background
  category: { bg: "#eff5fd", accent: "#1f6fc2", catColor: "#000000" }, // 2. Report Category
  results: { bg: "#eff5fd", accent: "#1f6fc2", catColor: "#000000" }, // 3. Lab Result
  evaluation: { bg: "#eef8f3", accent: "#2e7d62" }, // 4. Result Evaluation Summary
  summary: { bg: "#fdf6ea", accent: "#b26a00" }, // 5. Summarized MyBotGP Actions
  actions: { bg: "#fbf0f5", accent: "#ad3b72", catColor: "#000000" }, // 6. Follow on actions
};

// Outer paper for each numbered section
export const sectionPaperSx = (key) => {
  const { bg, accent } = SECTION_THEMES[key];
  return {
    p: 3,
    mb: 3,
    backgroundColor: bg,
    border: `1px solid ${accent}33`,
    borderLeft: `6px solid ${accent}`,
    borderRadius: 2,
  };
};

// h5 heading for each numbered section (font size untouched)
export const sectionHeadingSx = (key) => {
  const { accent } = SECTION_THEMES[key];
  return {
    fontWeight: 800,
    color: accent,
    mb: 2,
    pb: 1,
    borderBottom: `3px solid ${accent}`,
  };
};

// White inner card that sits on top of a pastel section paper
export const innerCardSx = (key) => {
  const { accent } = SECTION_THEMES[key];
  return {
    p: 2,
    mb: 2,
    backgroundColor: "#ffffff",
    border: "1px solid #e3e8ee",
    borderLeft: `5px solid ${accent}`,
    borderRadius: 1.5,
  };
};
